/*
 * Marks all but the last two breadcrumb crumbs (parent + current page) with
 * `.breadcrumb-desktop-only`, which vehicle-mega-menu.css hides below 750px.
 * Works on any `.subcol-breadcrumb` regardless of how many crumbs it has or
 * whether they're nested inside a `display:contents` wrapper (used on the
 * product page for the via_collection swap) - querySelectorAll traverses the
 * DOM tree, not the rendered box tree, so nesting doesn't affect the count.
 *
 * The [data-breadcrumb-vehicle]/[data-breadcrumb-category] wrapper spans
 * themselves are excluded from the count: they're `display:contents` (so
 * they don't render as their own segment), but hiding one directly would
 * still hide every real crumb inside it via the normal display:none cascade.
 */
(function () {
  function collapse(nav) {
    var segments = nav.querySelectorAll(
      'a, span:not([data-breadcrumb-vehicle]):not([data-breadcrumb-category])'
    );
    var total = segments.length;
    if (total <= 4) return;
    for (var i = 0; i < total - 4; i++) {
      segments[i].classList.add('breadcrumb-desktop-only');
    }
  }

  document.querySelectorAll('.subcol-breadcrumb').forEach(collapse);
})();
